const isPressing = /* @__PURE__ */ new WeakSet();
export {
  isPressing
};
